import React, { useEffect } from "react"

export const C = {
  bg: "#FBF4E8",
  card: "#FFFDF8",
  panel: "#F0E2CB",
  border: "#E8D9BE",
  borderDark: "#E0CCA8",
  ink: "#3B2E22",
  rust: "#B4532F",
  rustDark: "#8F3E20",
  gold: "#D9A441",
  goldDark: "#A87B27",
  muted: "#8A7A64",
  dark: "#3B2E22",
  darkCard: "#4A3B2C",
  highlight: "#FDF0DC",
  tan: "#C9B088",
}

export const F = {
  display: "'Bricolage Grotesque', sans-serif",
  body: "'Nunito', sans-serif",
}

const FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,500;12..96,700;12..96,800&family=Nunito:wght@500;600;700;800&display=swap"

export function useBallparkFonts() {
  useEffect(() => {
    if (document.querySelector(`link[href="${FONTS_HREF}"]`)) return
    const link = document.createElement("link")
    link.rel = "stylesheet"
    link.href = FONTS_HREF
    document.head.appendChild(link)
  }, [])
}

export function Screen({ dark = false, children, style }) {
  return (
    <div
      style={{
        minHeight: "100dvh",
        background: dark ? C.dark : C.bg,
        color: dark ? C.bg : C.ink,
        fontFamily: F.body,
        display: "flex",
        flexDirection: "column",
        padding: "24px 20px 28px",
        boxSizing: "border-box",
        maxWidth: 520,
        margin: "0 auto",
        width: "100%",
        ...style,
      }}
    >
      {children}
    </div>
  )
}

const buttonStyles = {
  rust: { background: C.rust, color: C.bg, shadow: C.rustDark },
  gold: { background: C.gold, color: C.ink, shadow: C.goldDark },
  panel: { background: C.panel, color: C.ink, shadow: "transparent" },
  ghost: { background: "transparent", color: C.rust, shadow: "transparent" },
}

export function BpButton({ variant = "rust", onClick, disabled, children, style }) {
  const v = buttonStyles[variant]
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        height: 56,
        border: "none",
        borderRadius: 16,
        background: v.background,
        color: v.color,
        fontWeight: 800,
        fontSize: 17,
        fontFamily: F.display,
        boxShadow: v.shadow === "transparent" ? "none" : `0 4px 0 ${v.shadow}`,
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.45 : 1,
        width: "100%",
        ...style,
      }}
    >
      {children}
    </button>
  )
}

export function Pill({ children, style }) {
  return (
    <span
      style={{
        background: C.panel,
        border: `1.5px solid ${C.borderDark}`,
        borderRadius: 999,
        padding: "5px 12px",
        fontWeight: 800,
        fontSize: 13,
        letterSpacing: 1,
        ...style,
      }}
    >
      {children}
    </span>
  )
}

export function PlayerDot({ color, size = 22 }) {
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: color,
        display: "inline-block",
        flexShrink: 0,
      }}
    />
  )
}

export function ChipToken({ color, used = false, size = 34 }) {
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: color,
        border: `${size > 28 ? 4 : 3}px dashed ${C.bg}`,
        outline: `3px solid ${color}`,
        display: "inline-grid",
        placeItems: "center",
        color: C.bg,
        fontWeight: 800,
        fontSize: size > 28 ? 13 : 11,
        opacity: used ? 0.35 : 1,
        boxSizing: "border-box",
      }}
    >
      1
    </span>
  )
}

export function OddsBadge({ odds }) {
  return (
    <span
      style={{
        background: C.ink,
        color: C.bg,
        fontWeight: 800,
        fontSize: 12,
        padding: "3px 8px",
        borderRadius: 8,
      }}
    >
      {odds}×
    </span>
  )
}
